<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('商城头条.标题')">
                <a-input
                  v-model="queryParam.title"
                  @pressEnter="handleQuery"
                  :placeholder="$t('通用.输入.请输入') + $t('商城头条.标题')"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('商城头条.是否首页展示')">
                <a-select v-model="queryParam.isHomeShow" :placeholder="$t('通用.输入.请选择')" allowClear>
                  <a-select-option :value="1">{{ $t('是') }}</a-select-option>
                  <a-select-option :value="0">{{ $t('否') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('商城头条.所属分类')">
                <a-select v-model="queryParam.categoryId" :placeholder="$t('通用.输入.请选择')" allowClear>
                  <a-select-option v-for="(d, index) in dict.type['news_headline_category']" :key="index" :value="d.value">
                    {{ d.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery">
                  <a-icon type="search" />{{ $t('通用.按钮.查询') }}
                </a-button>
                <a-button style="margin-left: 8px" @click="resetQuery">
                  <a-icon type="redo" />{{ $t('通用.按钮.重置') }}
                </a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 操作按钮 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['news:headline:add']">
          <a-icon type="plus" />{{ $t('通用.按钮.新增') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['news:headline:remove']">
          <a-icon type="delete" />{{ $t('通用.按钮.删除') }}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['news:headline:export']">
          <a-icon type="download" />{{ $t('通用.按钮.导出') }}
        </a-button>
      </div>

      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList" />

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="coverImage" slot-scope="text, record">
          <img
            v-if="record.coverImage"
            :src="record.coverImage"
            style="width: 60px; height: 60px; object-fit: cover"
            @click="handlePreview(record.coverImage)"
            alt="封面图"
          />
        </span>
        <span slot="isHomeShow" slot-scope="text, record">
          <a-switch :checked="record.isHomeShow === 1" @change="handleSwitch(record)" />
        </span>
        <span slot="publishTime" slot-scope="text, record">
          {{ parseTime(record.publishTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record)" v-hasPermi="['news:headline:edit']">
            <a-icon type="edit" />{{ $t('通用.按钮.修改') }}
          </a>
          <a-divider type="vertical" />
          <a @click="handleDelete(record)" v-hasPermi="['news:headline:remove']">
            <a-icon type="delete" />{{ $t('通用.按钮.删除') }}
          </a>
        </span>
      </a-table>

      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />

      <!-- 图片预览 -->
      <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageHeadline, delHeadline, updateHeadline, exportHeadline } from '@/api/news/headline'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Headline',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  dicts: ['news_headline_category'],
  data() {
    return {
      list: [],
      loading: false,
      total: 0,
      selectedRowKeys: [],
      multiple: true,
      previewVisible: false,
      previewUrl: '',
      queryParam: {
        title: undefined,
        isHomeShow: undefined,
        categoryId: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        { title: this.$t('商城头条.标题'), dataIndex: 'title', ellipsis: true },
        { title: this.$t('商城头条.封面图'), dataIndex: 'coverImage', scopedSlots: { customRender: 'coverImage' }, width: 100 },
        { title: this.$t('商城头条.是否首页展示'), dataIndex: 'isHomeShow', scopedSlots: { customRender: 'isHomeShow' }, width: 120 },
        { title: this.$t('商城头条.排序'), dataIndex: 'sort', width: 80 },
        { title: this.$t('商城头条.发布时间'), dataIndex: 'publishTime', scopedSlots: { customRender: 'publishTime' }, width: 160 },
        { title: this.$t('商城头条.创建时间'), dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' }, width: 160 },
        { title: this.$t('通用.文本.操作'), dataIndex: 'operation', scopedSlots: { customRender: 'operation' }, width: 150 }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      pageHeadline(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = { pageNum: 1, pageSize: 10 }
      this.handleQuery()
    },
    handlePreview(url) {
      this.previewUrl = url
      this.previewVisible = true
    },
    handleSwitch(record) {
      const isHomeShow = record.isHomeShow === 1 ? 0 : 1
      updateHeadline({ id: record.id, isHomeShow }).then(() => {
        this.$message.success(this.$t('通用.文本.修改成功'))
        this.getList()
      })
    },
    handleDelete(row) {
      const that = this
      const ids = row.id || this.selectedRowKeys
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        content: '',
        okText: this.$t('通用.按钮.确定'),
        okType: 'danger',
        cancelText: this.$t('通用.按钮.取消'),
        onOk() {
          const data = []
          if (Array.isArray(ids)) {
            ids.forEach(id => data.push({ id }))
          } else {
            data.push({ id: ids })
          }
          delHeadline(data).then(() => {
            that.$message.success(that.$t('通用.文本.删除成功'))
            that.getList()
          })
        }
      })
    },
    handleExport() {
      exportHeadline(this.queryParam).then(response => {
        this.download(response.msg)
      })
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
      this.multiple = !selectedRowKeys.length
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    }
  }
}
</script>
